import { useCallback } from "react";

import { FeatureIslandCategoryQuestionForMain } from "@/components/features/_layouts/island/main-with-category/components/category-main-question";

import { CheckboxField } from "@/components/ui/form/fields/check-box-field/check-box";

import { useRoomIsShowStockPreview } from "./hooks";

export const QuestionRoomIsShowStockPreview = () => {
	const { isShowStockPreview, onSetIsShowStockPreview: _onSetIsShowStockPreview } =
		useRoomIsShowStockPreview();

	const onSetIsShowStockPreview = useCallback(
		(value: boolean) => {
			_onSetIsShowStockPreview(value);
		},
		[_onSetIsShowStockPreview],
	);

	// default-input-model で初期化される運用だが、型上 optional のため安全側に倒す。
	if (!isShowStockPreview) return null;

	const checked = isShowStockPreview.value ?? false;

	return (
		<FeatureIslandCategoryQuestionForMain
			required={false}
			title={"在庫プレビュー表示"}
			isEdited={Boolean(isShowStockPreview.isEdited)}
			hasError={Boolean(isShowStockPreview.error)}
			guide="ON にすると、ゲスト予約フローの部屋選択画面でこの部屋の残在庫数（『残り N 室』『空きあり』）が表示されます。旅行会社からの在庫問い合わせを減らせる一方、競合に在庫状況が見えるリスクもあるため、運営方針に応じて設定してください。"
			inputChildren={
				<CheckboxField
					value={checked}
					label={"在庫プレビューを表示する"}
					handleChange={onSetIsShowStockPreview}
					errorMessage={isShowStockPreview.error}
				/>
			}
		/>
	);
};

QuestionRoomIsShowStockPreview.displayName = "QuestionRoomIsShowStockPreview";
